export default {
  'pages.markets.subtitle.apps': '发现并开通各类业务应用，丰富工作台能力。',
  'pages.markets.subtitle.skill':
    '探索丰富的 Skill 插件与能力，提升 AI 智能助手效能。',
  'pages.markets.subtitle.mcp':
    '发现并连接 MCP 服务与工具，拓展 AI 外部集成与调用能力。',
  'pages.markets.subtitle.digital_human':
    '发现并启用官方数字人，快速复用预置指令与关联 Skill。',
  'pages.markets.subtitle.plugin':
    '发现职阅客户端插件，下载安装包扩展客户端能力。',
  'pages.markets.tab.apps': '应用市场',
  'pages.markets.tab.skill': 'Skill 市场',
  'pages.markets.tab.mcp': 'MCP 市场',
  'pages.markets.tab.digital_human': '数字人市场',
  'pages.markets.tab.plugin': '插件市场',
  'pages.markets.sources': '来源',
  'pages.markets.source.all': '全部',
  'pages.markets.source.official': '官方',
  'pages.markets.skillsShCountTooltip':
    'skills.sh 共收录 {count} 个 Skill，可浏览榜单前 600 个',
  'pages.markets.search': '搜索',
  'pages.markets.searchPlaceholder.apps': '搜索应用名称、描述或开发者...',
  'pages.markets.searchPlaceholder.skill':
    '搜索 Skill 名称、功能描述或发布方...',
  'pages.markets.searchPlaceholder.mcp':
    '搜索 MCP 工具名称、功能描述或发布方...',
  'pages.markets.searchPlaceholder.digital_human':
    '搜索数字人名称、能力描述或发布方...',
  'pages.markets.searchPlaceholder.plugin': '搜索插件名称、编码或描述...',
  'pages.markets.sort.popular': '最受欢迎',
  'pages.markets.sort.latest': '最新上线',
  'pages.markets.sort.name': '名称',
  'pages.markets.sort.all_time': '总榜',
  'pages.markets.sort.trending': '趋势',
  'pages.markets.sort.hot': '热门',
  'pages.markets.sortDisabledWithKeyword': '搜索时排序不生效',
  'pages.markets.categories': '分类',
  'pages.markets.all': '全部',
  'pages.markets.loadedProgress': '已加载 {loaded} / 共 {total}',
  'pages.markets.loadedSimple': '已加载 {loaded}',
  'pages.markets.empty': '暂无市场内容',
  'pages.markets.noMatchingResults': '未找到符合条件的内容',
  'pages.markets.emptyDescription': '请尝试调整搜索关键字或切换分类。',
  'pages.markets.loadError': '市场数据加载失败',
  'pages.markets.loadErrorDesc': '暂时无法获取市场数据，请检查网络后重试。',
  'pages.markets.failedSourcesWarning': '以下来源暂时无法加载：{sources}',
  'pages.markets.retry': '重试',
  'pages.markets.refresh': '刷新',
  'pages.markets.clearFilters': '清空筛选',
  'pages.markets.loadingMore': '加载中...',
  'pages.markets.noMore': '没有更多了',
  'pages.markets.loadMoreRetry': '加载失败，点击重试',
  'pages.markets.action.open': '打开应用',
  'pages.markets.action.install': '安装',
  'pages.markets.action.installed': '已开通',
  'pages.markets.action.freeActivate': '免费开通',
  'pages.markets.action.paidActivate': '购买开通',
  'pages.markets.action.contactRequired': '联系运营',
  'pages.markets.action.copyCommand': '复制安装命令',
  'pages.markets.visitHomepage': '访问官方网站',
  'pages.markets.viewOnSource': '在 {source} 查看',
  'pages.markets.codeRepository': '代码仓库',
  'pages.markets.links': '相关链接',
  'pages.markets.installCommand': '安装命令',
  'pages.markets.serviceEndpoint': '服务地址',
  'pages.markets.thirdPartyDisclaimer':
    '该内容来自第三方来源，珊瑚礁未做审核，请确认来源可信后再安装。',
  'pages.markets.sourceLabel': '来源',
  'pages.markets.versionLabel': '版本',
  'pages.markets.installsLabel': '安装量',
  'pages.markets.identifierLabel': '标识',
  'pages.markets.copy': '复制',
  'pages.markets.copySuccess': '安装命令已复制到剪贴板',
  'pages.markets.copyEndpointSuccess': '服务地址已复制到剪贴板',
  'pages.markets.copyFailed': '复制失败，请手动复制',
  'pages.markets.unknownPublisher': '未知发布方',
  'pages.markets.unknownDeveloper': '未知开发者',
  'pages.markets.noDescription': '暂无详细介绍',
  'pages.markets.officialBadge': '官方',
  'pages.markets.featuredBadge': '推荐',
  'pages.markets.verifiedBadge': '来源方认证',
  'pages.markets.appBadge': '应用',
  'pages.markets.free': '免费',
  'pages.markets.paid': '付费',
  'pages.markets.pricePending': '待定价',
  'pages.markets.installs': '{count} 次安装',
  'pages.markets.downloads': '{count} 次下载',
  'pages.markets.version': 'v{version}',
  'pages.markets.detailTitle': '应用详情',
  'pages.markets.description': '介绍',
  'pages.markets.developer': '开发者',
  'pages.markets.certification': '认证状态',
  'pages.markets.official': '官方认证',
  'pages.markets.unverified': '第三方',
  'pages.markets.category': '分类',
  'pages.markets.uncategorized': '未分类',
  'pages.markets.price': '价格',
  'pages.markets.previewImages': '功能预览',
  'pages.markets.noPreview': '暂无预览图片',
  'pages.markets.previewAlt': '{name} 预览图 {index}',
  'pages.markets.confirmFreeTitle': '确认免费开通',
  'pages.markets.confirmFreeDescription':
    '确认开通应用「{name}」？开通后即可在工作台使用。',
  'pages.markets.confirmPaidTitle': '确认购买开通',
  'pages.markets.confirmPaidDescription':
    '确认购买应用「{name}」（{price}）？即将前往收银台。',
  'pages.markets.confirm': '确认',
  'pages.markets.cancel': '取消',
  'pages.markets.activateSuccess': '应用开通成功',
  'pages.markets.alreadyActive': '该应用在当前租户中已处于开通状态',
  'pages.markets.activateError': '开通失败，请稍后重试',
  'pages.markets.installSuccess': '安装成功',
  'pages.markets.installError': '安装失败，请稍后重试',
  'pages.markets.skillPackageMissing': '该 Skill 暂未提供安装包',
  'pages.markets.orderError': '订单创建失败，请稍后重试',
  'pages.markets.contactReason': '该应用需联系运营人员开通。',
  'pages.markets.unavailableUrl': '暂未配置可用的访问地址',
  'pages.markets.close': '关闭',
  'pages.markets.action.download': '下载',
  'pages.markets.downloadError': '下载失败，请稍后重试',
  'pages.markets.pluginEngine': '兼容引擎',
  'pages.markets.pluginPermissions': '插件权限',
  'pages.markets.pluginNoPermissions': '无需额外权限',
  'pages.markets.pluginPermission.http': '网络请求',
  'pages.markets.pluginPermission.commands': '执行命令',
  'pages.markets.pluginPermission.storage': '本地存储',
  'pages.markets.pluginPackageSize': '安装包大小',
  'pages.markets.pluginUpdatedAt': '更新时间',
  'pages.markets.pluginReadme': '使用说明',
  'pages.markets.pluginVersions': '版本记录',
  'pages.markets.pluginLatestTag': '当前版本',
  'pages.markets.pluginDownloadLatest': '下载最新版本',
};
